export const ENV_PRODUCTION = 'production';
export const ENV_DEVELOPMENT = 'development';